import { adminApi } from './api';

const SUPPORTED_TEMPLATES = new Set([
  'courses', 'questions', 'modules', 'resources',
  'quiz_subjects', 'simulation_lots', 'simulations',
]);

export async function downloadXlsxTemplate(kind) {
  if (!SUPPORTED_TEMPLATES.has(kind)) {
    throw new Error('Catégorie de modèle Excel inconnue');
  }
  const blob = await adminApi.downloadXlsxTemplate(kind);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'modele_' + kind + '.xlsx';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
